export class Comentarios { 
    /** constructor */
    constructor() {

    }

    setVerMas(){
        $(".valor").each(function() {
			var $comentario = $(this);
			var text = $comentario.text().trim();
			var screenWidth = $(window).width();
			var maxLength = 90;

			if(screenWidth && screenWidth > 1000 && screenWidth < 1200){
				maxLength = 90;
			}else if(screenWidth && screenWidth > 1200 && screenWidth < 1300){
				maxLength = 110;
			}else{
				maxLength = 130;
			}

			if (text.length > maxLength) {
			  $comentario.html(text.slice(0, maxLength) + "..." + '<span class="ver-mas text-primary">'+x_textos['390-0']+'</span>');
			  var $verMas = $comentario.find(".ver-mas");
			  $verMas.show();
		
			  $verMas.on("click", function() {
				$comentario.text(text);
				$verMas.hide();
			  });
			}
		  }); 
    }
   
}